<template>
    <div class="bannerContainer">
        <div id="bannerBg">
            <div>
                <p id="bannerTitle">智慧水务解决方案</p>
                <ul id="bannerText">
                    <li><span></span>降低产销差解决方案</li>
                    <li><span></span>安全供水解决方案</li>
                    <li><span></span>节约供水能耗</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Screen1',
    methods:{
        returnTop:function(dis){
            document.querySelector(dis).scrollIntoView({behavior:'smooth',block:'center'});
        }
    }
}
</script>

<style scoped>
    .bannerContainer{
        padding-top: 50px;
        background: #252b3a;
    }
    #bannerBg{
        margin: 0 auto;
        width: 885px;
        height: 335px;
        background: url(../../assets/imgs/service/banner.png) no-repeat;
        background-position:right;
        color: #fff
    }
    #bannerBg>div{
        padding: 110px 0 75px 85px; 
    }
    #bannerTitle{
        font-size: 24px;
        margin-bottom: 25px;
    }
    #bannerText{
        width: 410px;
        line-height: 22px;
    }
    #bannerText>li>span{
        display: inline-block;
        width: 7px;
        height: 7px;
        border-radius: 50% 50%;
        background: #28afff;
        margin-right: 15px;
        margin-left: 7px;
    }   
</style>
